import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';

import { TreoDateRangeModule } from 'tsui/@treo';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SharedModule } from 'app/shared/shared.module';
import { CalendarComponent } from 'app/modules/calendar/calendar.component';
import { CalendarSidebarComponent } from 'app/modules/calendar/sidebar/sidebar.component';
import { CalendarFilterComponent } from 'app/modules/calendar/calendar-filter/calendar-filter.component';
import { calendarRoutes } from 'app/modules/calendar/calendar.routing';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatDividerModule,
  MatMomentDateModule,
  MatRadioModule,
  MatSelectModule,
  MatProgressBarModule,
  MatSnackBarModule,
  MatSidenavModule,
  MatTooltipModule,
];

@NgModule({
  declarations: [CalendarComponent, CalendarSidebarComponent, CalendarFilterComponent],
  imports: [
    RouterModule.forChild(calendarRoutes),
    ScrollingModule,
    ClipboardModule,
    FullCalendarModule,
    TreoDateRangeModule,
    SharedModule,
    ...MATERIAL_MODULES,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD.MM.YYYY',
        },
        display: {
          dateInput: 'DD.MM.YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'DD.MM.YYYY',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class CalendarModule {}
